import React from 'react';
import PropTypes from 'prop-types';
import Translate from 'components/Translate';
import SilverButton from "../components-new/buttons/SilverButton";
import BlueButton from "../components-new/buttons/BlueButton";

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  exitButton: {
    marginRight: '10px',
  },
  sendButton: {
    marginBottom: 'unset',
  }
};

const ProceedAndExitButtons = ({proceedAction, exitAction}) => (
  <div style={styles.wrapper}>
    <SilverButton styles={{marginRight:'20px'}} type={'button'} onClick={exitAction} width={'100%'} children={<Translate text="cancel"/>}/>
    <BlueButton type={'button'} onClick={proceedAction} width={'100%'} children={<Translate text="submit"/>}/>
  </div>

);

ProceedAndExitButtons.propTypes = {
  proceedAction: PropTypes.func.isRequired,
  exitAction: PropTypes.func.isRequired,
};

export default ProceedAndExitButtons;



// WEBPACK FOOTER //
// ./src/components/ProceedAndExitButtons.jsx